import { indigo as c, red as l, green as u, yellow as a, brown as i, deepOrange as s, blueGrey as p, teal as g, pink as h, purple as f } from "@mui/material/colors";
function d(e) {
  let t = 0, r;
  for (r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t);
  let n = "#";
  for (r = 0; r < 3; r += 1) {
    const o = t >> r * 8 & 255;
    n += `00${o.toString(16)}`.slice(-2);
  }
  return n;
}
function y(e) {
  const t = d(e), r = e.split(" ");
  return {
    bgcolor: t,
    initials: `${r[0][0] ? r[0][0] : ""}${r.length > 1 ? r[1][0] : ""}`
  };
}
const A = (e) => Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(e);
function C(e) {
  const t = e.replace(/<[^>]*>/g, ""), r = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
    "&#x2F;": "/",
    "&#x60;": "`",
    "&#x3D;": "=",
    "&nbsp;": " "
  };
  return t.replace(/&[a-zA-Z0-9#]+;/g, (n) => r[n] || n);
}
function b(e) {
  const t = [
    c[500],
    l[900],
    u[500],
    a[500],
    i[500],
    s[500],
    p[500],
    g[500],
    h[500],
    f[500]
  ];
  return e < t.length ? t[e] : `hsl(${e * 137.508 % 360}, 65%, 60%)`;
}
function w(e) {
  try {
    return encodeURIComponent(e).replace(/%20/g, "+").replace(/%[0-9A-F]{2}/g, (t) => t.toLowerCase());
  } catch {
    return e;
  }
}
function D(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return e;
  }
}
export {
  A as formatMoney,
  b as getColorForIndex,
  y as stringAvatar,
  C as stripHtmlAndDecode,
  D as urlDecode,
  w as urlEncode
};
//# sourceMappingURL=strings.js.map
